<div [class]="direction" [ngClass]="isDesktop ? 'w-[30rem]' : 'w-full'">
  <form [formGroup]="calendarForm" class="flex flex-col px-2 max-w-full">
    <!--
      a11y: close (X) is now FIRST in DOM (order-2 keeps it visually on the
      trailing side; the icon+heading group is order-1 visually leading) and
      marked with [focusInitial]=true. Visible on mobile too so keyboard /
      SR users always have a top close target with initial focus on open.
    -->
    <div class="flex justify-between pb-2">
      <mot-button matType="icon" icon="close"
        [ariaLabel]="closeText"
        class="!border-none !w-min !h-min cursor-pointer !bg-transparent order-2" iconClass="!text-2xl"
        [focusInitial]="true"
        (onClick)="closeCard()" />
      <div class="flex gap-2 items-center gap-2 order-1">
        <ng-icon class="text-2xl" name="calendar-plus" aria-hidden="true" />
        <h2 class="text-base m-0 text-[#0C3058]">{{headerText}}</h2>
      </div>
    </div>

    <div class="flex flex-col gap-2 pt-2 pb-4">
      <span class="text-base font-normal text-[#0C3058]">{{descText}}</span>
      <mot-input formControlName="emailAddress" pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
        type="email" [placeholder]="mailText" class="w-full" [displayErrors]="false" [dir]="direction" />
      </div>

      <div class="flex gap-2 !sticky bottom-2 pb-2 pt-3 w-full" [ngClass]="isDesktop ? 'justify-end' : 'justify-center flex-col'">
        <mot-loading-button
          [disabled]="!calendarForm.valid || isSubmitting"
          [isLoading]="false"
          buttonClass="not-disabled:!bg-primary w-full !text-white !rounded-lg !align-middle !px-2 !py-3 !h-[3rem]"
          [ngClass]="isSubmitting ? 'opacity-50 cursor-not-allowed' : ''"
          [text]="sendText"
          (onClick)="sendEmail()" />

          <mot-button buttonClass="!bg-transparent w-full !text-black !align-middle !px-2 !py-3 !h-[3rem]"
          [text]="cancelText" (onClick)="closeCard()"></mot-button>
        </div>
      </form>
    </div>
